'use client';

import { Loader } from '@/shared/components/Loader';

export function FullPageLoader({ text }: { text: string }) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader text={text}></Loader>
      </div>
    );
}